export default __webpack_public_path__ + "static/media/Regua_nova.42b3f1f9.png";